import React from 'react'
import { render } from 'react-dom'
import { App } from './app/App'
import { createRoutes } from './routing/routes'

const routes = createRoutes()

render(<App routes={routes} />, document.getElementById('root'))

// if (module.hot) {
//   module.hot.accept()
// }
